(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gr-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-personalization')) {
    customElements.define('gr-personalization', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const input = this.querySelector('[data-gr-name]');
        const form = this.closest('form');
        const validate = () => {
          const value = input.value.trim();
          const valid = !value || value.split(/\s+/u).length <= 2;
          input.setCustomValidity(valid ? '' : this.dataset.error);
          input.setAttribute('aria-invalid', String(!valid));
          return valid;
        };
        input.addEventListener('input', validate);
        const guard = event => {
          if (validate()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
          input.focus();
        };
        form.addEventListener('submit', guard, true);
        form.addEventListener('click', event => {
          if (event.target.closest('button[type="submit"], input[type="submit"]')) guard(event);
        }, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
